import { CopyEmployeeServicesModal } from '@app/pages/Employees/EditEmployee/components/ClientServicesTab/components/CopyEmployeeServicesModal';
import { ServiceSalaryComponent } from '@app/pages/Employees/EditEmployee/components/ClientServicesTab/components/ServiceSalaryComponent';
import { SetEmployeeSalaryModal } from '@app/pages/Employees/EditEmployee/components/ClientServicesTab/components/SetEmployeeSalaryModal';

export { CopyEmployeeServicesModal };
export { ServiceSalaryComponent };
export { SetEmployeeSalaryModal };
